import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import SearchSelectObserver from "../../generic/MySearchSelectObserver";
import CustomSpinner from "../../generic/CustomSpinner";
import $ from "jquery";


const AddEtapaVidaReligiosa = ({ handleForm, edicion = {}, hermanaId, ...props }) => {
    //("666666666666666666666666666666666666")
    //console.log(props)
    //console.log({ 'edicion': edicion })

    // Validación del formulario
    const [validated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [provincias, setProvincias] = useState()
    const [comunidades, setComunidades] = useState()
    const [votosRestantes, setVotosRestantes] = useState();
    const [resetSearchSelect, setResetSearchSelect] = useState(false);
    const methods = useForm({
        defaultValues: {
            date: edicion.date ? edicion.date : null,
            vowTypeId: edicion.vowTypeId ? edicion.vowTypeId : null,
            provinceId: edicion.community ? edicion.community?.province?.id : null,
            communityId: edicion.communityId ? edicion.communityId : null,
            id: edicion.id ? edicion.id : null
        },
    });

    useEffect(() => {
        handleObtenerProvincias();
        handleObtenerVotosRestantes();
        // console.log('ppppppppppppppppppppppppppppppppppppppppppppppp')
        // console.log(methods)
        // setValue('date', edicion.date, { shouldValidate: true })
         //setValue('vowTypeId', 10, { shouldValidate: true })

         //console.log(edicion)
    }, []);


    //formulario con valores por defecto
    
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
        getValues,
        watch,
      } = methods;
   
    const requestGetComunidades = (page = 1, findName = "", addMore = false) => {
        setLoading(true);
        let settings = {
            url: process.env.REACT_APP_API_URL + `/provincias/${getValues("provinceId")}/comunidades?page=${page}&findName=${findName}&todasComunidades=true`,
            method: "GET",
            timeout: 0,
            xhrFields: {
                withCredentials: true,
            },
        };
        return $.ajax(settings)
            .done((response) => {
                setLoading(false);
                addMore ? setComunidades([...comunidades, ...processComunidades(response.items)]) : setComunidades(processComunidades(response.items));
                return response;
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const processComunidades = (comunidades) => {
        return comunidades.map((comunidad) => {
            let nuevaComunidad = {};
            nuevaComunidad.name = comunidad.name;
            nuevaComunidad.value = comunidad.id;
            return nuevaComunidad;
        });
    };

    const handleObtenerVotosRestantes = async () => {
        setLoading(true);
        //console.log(process.env.REACT_APP_API_URL + "/hermanas/" + hermanaId + "/votosRestantes")
        let settings = {
            url: process.env.REACT_APP_API_URL + `/hermanas/${hermanaId}/votosRestantes${edicion.date ? '?allVows=true' : ''}`,
            method: "GET",
            timeout: 0,
            xhrFields: {
                withCredentials: true,
            },
        };
        $.ajax(settings)
            .done((response) => {
                //console.log('44444444444444444444444444444444444444444444444444444444444444444')
                //console.log(response)
                setLoading(false);
                setVotosRestantes(response);
            })
            .catch((e) => {
                //console.log('55555555555555555555555555555555555555555555555555555555555')
                //console.log(e)
                setLoading(false);
            });
    };

    const handleObtenerProvincias = () => {
        setLoading(true);
        //(`${process.env.REACT_APP_API_URL}/provincias?ended=true&dg=d`)
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/provincias?ended=true`,
            method: "GET",
            xhrFields: {
                withCredentials: true,
            },
        };
        return $.ajax(settings)
            .then((response) => {
                //console.log({ 'respuesta': response })
                setProvincias(response.items);
                setLoading(false);
            })
            .catch((e) => {
                //console.log(e)
                setLoading(false);
            });
    }


    const onSubmit = (data) => {
        //si no recupero los datos es POST si no es PUT
        handleForm(data, edicion.date ? false : true);
    };

    return (
        <Container className="my-5 position-relative">
            <CustomSpinner loading={loading} animation={"border"} />
            <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="border rounded p-4">
                <Form.Row>
                    <small className="mb-3">
                        Los campos con un <b>*</b> deben de ser rellenados.
                    </small>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} xs={12} md controlId="etapa-vida-religiosa">
                        <Form.Label>{"Etapa "} *</Form.Label>

                        <Form.Control name="vowTypeId" as="select" custom isInvalid={errors.vowTypeId} {...register("vowTypeId", { required: "Este campo es obligatorio" })}>
                            {votosRestantes &&
                                votosRestantes.map((voto) => (
                                    <option key={voto.id} value={voto.id} selected={voto.id === edicion.vowTypeId}>
                                        {voto.type}
                                    </option>
                                ))}
                        </Form.Control>
                        <small><ErrorMessage errors={errors} name="vowTypeId" /></small>

                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col} xs={12} md controlId="date-vida-religiosa">
                        <Form.Label>{"Fecha "} *</Form.Label>
                        <Form.Control
                            name="date"
                            type="date"
                            isInvalid={errors?.date}
                            {...register("date", { required: "Este campo es obligatorio" })}

                        />
                        <small><ErrorMessage errors={errors} name="date" /></small>
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col} xs={12} md controlId="provincia-vida-religiosa">
                        <Form.Label>{"Provincia "} *</Form.Label>
                        <Form.Control name="id_provincia" as="select" custom isInvalid={errors.provinceId} {...register("provinceId")}>
                            <option key="0" value="">- Seleccione una provincia - </option>
                            {provincias &&
                                provincias?.map((provincia) => (
                                    <option key={provincia.id} value={provincia.id} selected={provincia.id === edicion.community?.province?.id}>
                                        {provincia.name}
                                        
                                    </option>                                ))}
                        </Form.Control>
                        <small><ErrorMessage errors={errors} name="provinceId" /></small>
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col} xs={12} md controlId="comunidad-vida-religiosa">
                        <Form.Label>{"Comunidad "} *</Form.Label>
                        <SearchSelectObserver
                            options={comunidades}
                            name={"communityId"}
                            reactHookFormsRef={register("communityId", {
                                required: "Este campo es obligatorio",
                            })}
                            requestMoreOptions={requestGetComunidades}
                            methods={methods}
                            reset={resetSearchSelect}
                        />
                        {/* no se muestra el mensaje de error ni se guarda la primera provincia que se carga */}
                        <small><ErrorMessage errors={errors} name="communityId" /></small>
                    </Form.Group>
                </Form.Row>

                <Button variant="outline-primary" type="submit" className="my-3">
                    {"Guardar"}
                </Button>
            </Form>
        </Container>
    )
}

export default AddEtapaVidaReligiosa